import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminPricing() {
    const [trade, setTrade] = useState(20);
    const [vip, setVip] = useState(30);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        api.get("/admin/pricing").then(({ data }) => {
            setTrade(data.trade_discount_pct);
            setVip(data.vip_discount_pct);
        }).finally(() => setLoading(false));
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            await api.put("/admin/pricing", {
                trade_discount_pct: Number(trade),
                vip_discount_pct: Number(vip),
            });
            toast.success("Sconti aggiornati");
        } catch (err) {
            toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Errore");
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="text-[hsl(var(--muted-foreground))]">Caricamento…</div>;

    return (
        <div className="max-w-xl" data-testid="admin-pricing-page">
            <h1 className="font-serif text-3xl mb-2">Configurazione Prezzi</h1>
            <p className="text-sm text-[hsl(var(--muted-foreground))] mb-8">
                Definisci le percentuali di sconto applicate ai listini Trade e VIP sul prezzo pubblico.
                Un eventuale <em>price override</em> a livello di singolo formato ha sempre la priorità.
            </p>

            <form onSubmit={submit} className="space-y-6 bg-white border border-[hsl(var(--border))] rounded-sm p-6">
                <div>
                    <Label className="co-caption mb-2 block">Sconto Trade (%)</Label>
                    <Input
                        type="number" min="0" max="100" step="0.5"
                        value={trade}
                        onChange={(e) => setTrade(e.target.value)}
                        data-testid="pricing-trade-input"
                        className="bg-white"
                    />
                </div>
                <div>
                    <Label className="co-caption mb-2 block">Sconto VIP (%)</Label>
                    <Input
                        type="number" min="0" max="100" step="0.5"
                        value={vip}
                        onChange={(e) => setVip(e.target.value)}
                        data-testid="pricing-vip-input"
                        className="bg-white"
                    />
                </div>
                <button type="submit" disabled={saving} className="co-btn-primary" data-testid="pricing-save-btn">
                    {saving ? "Salvataggio…" : "Salva"}
                </button>
            </form>
        </div>
    );
}
